import { render, staticRenderFns } from "./wait_countdown.vue?vue&type=template&id=09a2baef&scoped=true"
import script from "./wait_countdown.vue?vue&type=script&lang=ts"
export * from "./wait_countdown.vue?vue&type=script&lang=ts"
import style0 from "./wait_countdown.vue?vue&type=style&index=0&id=09a2baef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a2baef",
  null
  
)

export default component.exports